import { Injectable } from '@angular/core';
import { RotasService } from '../services/rotas.service';
import { Observable, of } from 'rxjs';
import { take, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResolveRotasService {

  constructor(private rotaService: RotasService) { }

  resolve(): Observable<any> {
    return this.rotaService.page(10,1).pipe(
      take(1),
      mergeMap(teste => {
        return of(teste['object']);
      })
    );
  }
}
